import React, { useMemo } from "react";
import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "../../typography";
import "../../sda/styles.scss";
import { Link } from "@amzn/stencil-react-components/link";
import useArb from "../../../hooks/use-arb";
import moment from "moment";
import {
  IconCalendarFill,
  IconCheckCircleFill,
  IconLocationFill,
} from "@amzn/stencil-react-components/icons";
import "./style.scss";
import { SdaInfo } from "../../../utility/application-data";
import { formatedStartTime } from "../../../utility/time-processor";
import DOMPurify from "dompurify";
import {
  Expander,
  ExpanderChevronPosition,
} from "@amzn/stencil-react-components/expander";

interface StartDayDetailsProps {
  startDate: string;
  startTime: string;
  address: string;
  sdaDetails: SdaInfo;
}

export const StartDayDetails = ({
  startDate,
  startTime,
  address,
  sdaDetails,
}: StartDayDetailsProps) => {
  const bundle = useArb("HVHChecklistPantherResource");

  const whenAndWhere = bundle.getMessage(
    "Checklist-PreHireDetails-WhenAndWhere"
  );
  const googlePlaceURL = "http://maps.google.com/?q=";
  const googleMapLink = (
    <Link fontSize={"T200"} href={googlePlaceURL + address} target={"_blank"}>
      {address}
    </Link>
  );

  const dateWithTime = new Date(startDate + " " + formatedStartTime(startTime));
  const date = bundle.formatMessage("Checklist-PreHireDetails-Date", {
    dateTime: dateWithTime,
  });
  const time = bundle.formatMessage("Checklist-PreHireDetails-Time", {
    time:
      formatedStartTime(startTime) +
      " " +
      moment().tz(sdaDetails.timezone).zoneAbbr(),
  });
  const locationDetails = bundle.formatMessage(
    "Checklist-PreHireDetails-Location",
    {
      address: googleMapLink,
    }
  );
  const purifiedHtml = useMemo(
    () => DOMPurify.sanitize(sdaDetails.publicText),
    [sdaDetails.publicText]
  );

  const CustomRow = (children: any) => <Row gridGap="0.5rem">{children}</Row>;

  return (
    <Col className="flyout-content" gridGap="1rem" width="100%">
      <Row>
        <View width="100%">
          <Expander
            titleText={whenAndWhere}
            shouldExpandOnMount={true}
            chevronPosition={ExpanderChevronPosition.Trailing}
          >
            <Col gridGap="1rem">
              <CustomRow
                {...(
                  <>
                    <IconCalendarFill />
                    <Text>{date}</Text>
                  </>
                )}
              ></CustomRow>
              <CustomRow
                {...(
                  <>
                    <IconCheckCircleFill />
                    <Text>{time}</Text>
                  </>
                )}
              ></CustomRow>
              <CustomRow
                {...(
                  <>
                    <IconLocationFill />
                    <Text>{locationDetails}</Text>
                  </>
                )}
              ></CustomRow>
            </Col>
          </Expander>
        </View>
      </Row>
      <Row>
        <Text>
          <div
            className="sf-html-container"
            dangerouslySetInnerHTML={{ __html: purifiedHtml }}
          ></div>
        </Text>
      </Row>
    </Col>
  );
};
